export default class Constants {
  static TOKEN_NAME = `x-auth`;
  static PRIMARY = "#2979FF";
  static SECONDARY = "#1DFEBA";
  static DARK = "#00245B";
}
